export default __webpack_public_path__ + "static/media/hamburger.5e2f37d7.svg";